import { ref } from 'vue';
import type BDialog from '@/design-system/components/patterns/BDialog.vue';

export function useDialogExpansionPanel() {
    const dialogRef = ref<typeof BDialog | null>(null);

    const handleExpansionPanelChange = () => {
        setTimeout(() => {
            dialogRef.value?.recalculateHeight();
        }, 100);
    };

    return {
        dialogRef,
        handleExpansionPanelChange,
    };
}
